import { selectVendorUser, setToken } from "auth/VendorAuth/vendorUserSlice";
import axios from "axios";
import { useAppConfig } from "hooks/queries";
import { useCallback, useContext, useEffect } from "react";
import { AuthContext } from "react-oauth2-code-pkce";
import { useAppDispatch, useAppSelector } from "../../hooks/redux";

/**
 * Get Vendor Auth information
 * set axios default auth information
 */
export const useVendorAuth = () => {
  const authContext = useContext(AuthContext);
  const dispatch = useAppDispatch();
  // configure axios in setToken reducer
  useEffect(() => {
    if (!isAuthenticated) {
      dispatch(setToken(authContext.idToken));
    }
  }, [authContext.idToken]);

  let { isAuthenticated, isAuthContextConfigured } =
    useAppSelector(selectVendorUser);

  // isAuthenticated should be false when isAuthContextConfigured is false
  isAuthenticated = isAuthContextConfigured && isAuthenticated;

  return { ...authContext, isAuthenticated, isAuthContextConfigured };
};

export const useVendorLogout = () => {
  // External Hooks
  const dispatch = useAppDispatch();
  const { logOut } = useContext(AuthContext);
  const { data: appConfig } = useAppConfig();

  // Functions
  const vendorLogOut = useCallback((): void => {
    axios.post(`/api/v1/Account/logout`).finally(() => {
      logOut();
      dispatch(setToken(undefined));

      sessionStorage.removeItem("ROCP_tokenExpire");
      sessionStorage.removeItem("ROCP_refreshTokenExpire");
      sessionStorage.removeItem("ROCP_token");
      sessionStorage.removeItem("ROCP_idToken");
      sessionStorage.removeItem("PKCE_code_verifier");

      if (appConfig?.loginGov?.logoutEndpoint === null) {
        return;
      }

      var newLogout =
        appConfig?.loginGov?.logoutEndpoint +
        window.location.origin +
        `&state=${window.location}`;
      window.location.replace(newLogout);
    });
  }, [appConfig?.loginGov?.logoutEndpoint]);
  return { vendorLogOut };
};
